import { gql } from '@apollo/client'

export default gql`
  query CheckToken($token: String!) {
    checkToken(token: $token) {
      user {
        auser_id
        display_name
        email
        phone
        last_application_phone
        first_name
        last_name
        patronymic
        city
        gender
        birthday
        sport_types {
          id
          title
        }
        default_sport_key
        avatar {
          uri
        }
        roles {
          is_admin
          is_moderator
          is_federator
          is_super_federator
          has_organizations
          has_active_organizations
          has_calendars
          organization_tree {
            organization_id
            parent_organization1_id
            branchmark
            sport_type
            revise_state
            show_results_card
            level
          }
        }
        hasAgreementWithActiveDocument
      }
      self {
        auser_id
        roles {
          is_admin
          is_moderator
        }
      }
    }
  }
`
